// extracted by mini-css-extract-plugin
export default {"meal":"MealItem_meal__F9hME","description":"MealItem_description__QczfK","price":"MealItem_price__KEh6t"};